"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DEBOUNCE_TIMER = exports.DEFAULT_PAGE_SIZES = exports.DEFAULT_PAGE_SIZE = exports.SEARCH_COLUMN_NAME = exports.EXPANDER_COLUMN_NAME = exports.SELECTION_COLUMN_NAME = void 0;
exports.SELECTION_COLUMN_NAME = '_selection_';
exports.EXPANDER_COLUMN_NAME = '_expander_';
exports.SEARCH_COLUMN_NAME = '_all_';
exports.DEFAULT_PAGE_SIZE = 10;
exports.DEFAULT_PAGE_SIZES = [10, 25, 50];
exports.DEFAULT_DEBOUNCE_TIMER = 250;
//# sourceMappingURL=constants.js.map